var _path, _rect, _rect2, _rect3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotAuth = function SvgNotAuth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8754 4.71959C18.4578 2.25706 14.5244 2.2571 12.1069 4.71963C10.4555 6.40168 9.88197 8.88048 10.597 11.1294L3.61437 18.242C3.50867 18.3497 3.44922 18.4954 3.44922 18.6479V21.896C3.44922 22.2133 3.70132 22.4701 4.01287 22.4701H7.20157C7.35128 22.4701 7.49441 22.4096 7.60008 22.3019L8.39712 21.4895C8.51876 21.3656 8.5782 21.1917 8.5584 21.0174L8.45931 20.1449L9.64606 20.0311C9.91579 20.0053 10.1288 19.7883 10.1541 19.5136L10.2659 18.3047L11.1224 18.4062C11.2814 18.4281 11.4416 18.3737 11.5622 18.2649C11.6822 18.1556 11.751 17.9997 11.751 17.836V16.767H12.7814C12.9311 16.767 13.0742 16.7064 13.1799 16.5988L14.6254 15.1459C16.8326 15.8748 19.2241 15.3345 20.8754 13.6513C23.2929 11.1888 23.2929 7.18213 20.8754 4.71959ZM19.2808 8.77955C18.6214 9.45126 17.5491 9.45126 16.8897 8.77955C16.2303 8.10784 16.2303 7.01563 16.8897 6.34392C17.5491 5.67221 18.6214 5.67221 19.2808 6.34392C19.9403 7.01563 19.9402 8.10784 19.2808 8.77955Z",
    fill: "#9F9F9F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.77417,
    height: 26.2125,
    rx: 1.38709,
    transform: "matrix(0.700557 -0.713596 0.700557 0.713596 2.90234 4.29068)",
    fill: "#9F9F9F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.19734,
    height: 26.2125,
    rx: 1.09867,
    transform: "matrix(0.700557 -0.713596 0.700557 0.713596 5.09766 2.56412)",
    fill: "#F4F5F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.9031,
    height: 26.2125,
    rx: 0.951552,
    transform: "matrix(0.700557 -0.713596 0.700557 0.713596 0 4.02505)",
    fill: "#F4F5F6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotAuth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not_auth.307feeca.svg";
export { ForwardRef as ReactComponent };